import { useErrorHandler } from 'components/error'
import { useSalvarJustificativaVisualizarProntuarioMutation } from 'graphql/hooks.generated'
import { useCallback } from 'react'

import { JustificativaFormModel } from './modal/JustificativaModal'
import { useJustificativaVerProntuarioId } from './useJustificativaVerProntuarioId'

export const useSubmitJustificativaVisualizarProntuario = (cidadaoId: ID) => {
  const handleRejection = useErrorHandler()
  const [salvarJustificativaVisualizarProntuario] = useSalvarJustificativaVisualizarProntuarioMutation()

  const pathCidadao = `/cidadao/${cidadaoId}`
  const [, setJustificativaId, deleteJustificativaId] = useJustificativaVerProntuarioId(pathCidadao, cidadaoId)

  const submitJustificativa = useCallback(
    (prontuarioId: ID, values: JustificativaFormModel) => {
      return salvarJustificativaVisualizarProntuario({
        variables: { input: { prontuarioId: prontuarioId, justificativa: values.justificativa } },
      })
        .then(({ data }) => {
          const justificativaId = data?.salvarJustificativaVisualizarProntuario

          if (justificativaId) {
            setJustificativaId(justificativaId)
          }

          return justificativaId
        })
        .catch(handleRejection)
    },
    [salvarJustificativaVisualizarProntuario, handleRejection, setJustificativaId]
  )

  return {
    submitJustificativa,
    clearJustificativa: deleteJustificativaId,
  }
}
